module.exports = __webpack_public_path__ + "img/arrow-circle-left.5b9540ce.svg";